import { useFormKeysQuery } from '@uplift/queries';

export type FormKeysType = 'phq9' | 'gad7';

export const useFormKeys = <T extends FormKeysType>(_formKeys: T[]) => {
  const { data, isLoading } = useFormKeysQuery();

  if (data && !isLoading) {
    return Object.keys(data).reduce((acc, formId) => ({
      ...acc,
      [data[formId]]: formId
    }), {} as {[key in T]: string});
  }
};
